<form [formGroup]="contactDetailsForm()" novalidate>
    <ap-grid-row>
        @if (contactDetailsForm().controls.emailAddress) {
            <ap-grid-col [md]="6">
                <ap-email-input
                    formControlName="emailAddress"
                    autocomplete="email"
                    [messages]="errorMessagesEmail"
                    [label]="'contact.details.emailAddress.label' | apKeyOverride: contentKeyMap() | apContent"
                    data-testid="email"
                ></ap-email-input>
            </ap-grid-col>
        }
        @if (contactDetailsForm().controls.phoneNumber) {
            <ap-grid-col [md]="6">
                <ap-phone-input
                    formControlName="phoneNumber"
                    [numberFormat]="numberFormat()"
                    autocomplete="tel"
                    [messages]="errorMessagesPhone"
                    [label]="'contact.details.phoneNumber.label' | apKeyOverride: contentKeyMap() | apContent"
                    data-testid="phone"
                ></ap-phone-input>
            </ap-grid-col>
        }
    </ap-grid-row>
</form>
